import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles.scss';

const AddControl = ({ asSpan, children, className, ...props }) => {
  props = { className: classNames('add-control', className), ...props };

  if (asSpan) {
    return <span {...props}>+ {children}</span>;
  } else {
    return <a {...props}>+ {children}</a>;
  }
};

AddControl.propTypes = {
  asSpan: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default AddControl;
